export default __webpack_public_path__ + "static/media/ggplay-button.70888a97.png";